import authRules from '../authRules';

const sameResource = (user) => {
  const { sameResource } = user.securityLevels;
  if (sameResource >= authRules.sameResource.sameResource) {
      return true;
  } else {
      return false;
    }
  }


export default sameResource;


// WEBPACK FOOTER //
// ./src/AuthLogic/rules/sameResource.js